exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-choice-slider button[data-v-09d74b95] {\n  display: block;\n}", ""]);

// exports
